import { H5, H6, P } from "../../../../AbstractElements";
import { AppIdeaText, EstablishedNewTheAppIdeaRepository, ViewItOnGithub } from "../../../../Constant";

const AppIdeasTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-picture bg-primary">
        <i className="icon-pencil-alt" />
      </div>
      <div className="cd-timeline-content">
        <H5 className="m-0 vertical-timeline-element-subtitle">{EstablishedNewTheAppIdeaRepository}</H5>
        <P className="mb-0">{AppIdeaText}</P>
        <div className="time-content pt-2">
          <i className="icon-github"></i>
          <H6>{ViewItOnGithub}</H6>
        </div>
        <span className="cd-date">February 02 2022</span>
      </div>
    </div>
  );
};
export default AppIdeasTimeline;
